// utils/googleLoginUtils.ts

import { useGoogleLogin, TokenResponse } from '@react-oauth/google';
import { message } from 'antd';
import loginApi from '@/service/modules/loginApi'
import { updateUserInfo } from '@/store/slices/userInfoSlice';
import { useDispatch } from "react-redux"
import { setCookie } from '@/utils/cookie'
import { matomoSetCustomDimension } from "@/utils/matomoEvent"

interface GoogleLoginProps {
  onSuccessJump?: () => void;
  source?: string;
}

export const useGoogleLoginUtils = ({ onSuccessJump, source }: GoogleLoginProps) => {
  const dispatch = useDispatch();

  const onGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse: TokenResponse) => {
      try {
        console.log('Login Success:', tokenResponse);
        let res = await loginApi.googleLogin({ access_token: tokenResponse.access_token });
        if (res.data) {
          console.log(res, ' == res');
          message.success('Login Successful!');

          if (res.data.userBehaviorType == 'login') {
            // matomo记录登录结果
            let loginResult = 0
            if (window && (window as any)._paq) {
              (window as any)._paq.push(['setUserId', res.data.customerID]);
            }
            const loginMethod = source === 'checkout' ? 'chkGLogin' : 'gLogin';
            matomoSetCustomDimension(26, {loginMethod, loginResult})
          } else if (res.data.userBehaviorType == 'register') {
            // matomo记录注册结果
            let registerResult = 0
            const registerMethod = source === 'checkout' ? 'chkGRegister' : 'gRegister';
            matomoSetCustomDimension(27, {registerMethod, registerResult})
          }          

          // 保存 userEmail
          if (res.data.email) {
            localStorage.setItem('userEmail', res.data.email || '');
            setCookie('userCustomerId', res.data.customerID || '');
          } else {
            localStorage.removeItem('userEmail');
          }

          // 登录成功，跳转
          if (onSuccessJump) {
            dispatch(updateUserInfo(res.data));
            setTimeout(() => {
              onSuccessJump();
            }, 1500);
          }
        } else {
          message.error('Google Login Failure');
        }
      } catch (error: any) {
        message.error('Google Login Failure');

        // matomo 记录登录失败信息
        let loginResult = error.code;
        const loginMethod = source === 'checkout' ? 'chkGLogin' : 'gLogin';
        matomoSetCustomDimension(26, {loginMethod, loginResult});
      }
    },
    onError: () => {
      console.error('Google Login Failure');
      message.error('Google Login Failure');
    },
  });

  return onGoogleLogin;
};
